import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import { GlobalValidators } from './../../utils/validators';
import { AccountService } from '../../services/account.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  formErrors = [];
  forgotPasswordForm: FormGroup;
  forgotPasswordErrors = false;
  showForgotPasswordSignupForm = false;
  residentSelectData = ['NIC', 'Passport', 'BRN'];
  userAvailability;
  checkuserAvailability: boolean;
  userAvailabilityError: boolean;
  constructor(private fb: FormBuilder, private accountService: AccountService, private router: Router, public translate: TranslateService) { }

  async onforgotPassword(form) {
    if (form.invalid) {
      return;
    }
    try {
      this.checkuserAvailability = true;
      this.userAvailability = await this.checkUser(
        (this.forgotPasswordForm.get('nic').value && this.forgotPasswordForm.get('nic').value) ||
        this.forgotPasswordForm.get('passport').value ||
        (this.forgotPasswordForm.get('brn').value && this.forgotPasswordForm.get('brn').value),
        form.value.resident
      );
      this.checkuserAvailability = false;
    } catch (e) {
      this.checkuserAvailability = false;
    }
    if (
      !this.forgotPasswordForm.get('nic').value &&
      !this.forgotPasswordForm.get('passport').value &&
      !this.forgotPasswordForm.get('brn').value
    ) {
      this.forgotPasswordErrors = true;
    } else if (this.userAvailability) {
      this.showForgotPasswordSignupForm = true;
    } else {
      this.userAvailabilityError = true;
      this.forgotPasswordErrors = true;
    }
  }
  ngOnInit() {
    this.bindForgotPasswordForm();
  }
  bindForgotPasswordForm() {
    this.forgotPasswordForm = this.fb.group({
      resident: ['NIC'],

      nic: [
        '',
        [
          GlobalValidators.requireIf('resident', (c) => c.value === 'NIC'),
          (environment.dev && GlobalValidators.noop) || GlobalValidators.nic,
        ],
      ],
      passport: ['', [GlobalValidators.requireIf('resident', (c) => c.value === 'Passport'), GlobalValidators.omitSpecialCharators]],
      brn: ['', [GlobalValidators.requireIf('resident', (c) => c.value === 'BRN'), GlobalValidators.omitSpecialCharators]],
    });
    this.showForgotPasswordSignupForm = true;
    this.forgotPasswordForm.valueChanges.subscribe((value) => {
      this.userAvailabilityError = false;
    });
    this.forgotPasswordForm.get('resident').valueChanges.subscribe((value) => {
      if (value === 'NIC') {
        this.forgotPasswordForm.get('passport').setValue('');
      } else {
        this.forgotPasswordForm.get('nic').setValue('');
      }
    });
  }
  changeNIC(event) {
    this.showForgotPasswordSignupForm = false;
  }
  async checkUser(userId, type) {
    let { isExistingUser } = await this.accountService.isAvailableUser(userId, type);
    return isExistingUser;
  }
  goToLogin() {
    this.router.navigate(['/signin']);
  }
}
